export const questionData$ = state => state.question.questionData;
export const questionLoading$ = state => state.question.isLoading;
export const questionError$ = state => state.question.error;
export const selectedSection$ = state => state.question.selectedSection;
